import { AzureADAppPermissionScopeModel } from '../../../microsoft/azuread/profile/azure-adapp-permission-scope-model';
import { AzureADServicePrincipalSummaryModel } from '../../../microsoft/azuread/profile/azure-adservice-principal-summary-model';

export class AzureADServicePrincipalSummaryWithScopesModel extends AzureADServicePrincipalSummaryModel {
  scopes: AzureADAppPermissionScopeModel[];
}
